import React, { useState, useEffect, useMemo, JSX } from "react";
import { ThemeProvider } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { CssBaseline } from "@mui/material";

import { myTheme } from "./themes";
import { socket } from "./services/socket";

import { NotificationProvider } from "./componentes/notificationProvider";
import { usePages } from "./context/pageContext";
import api from "./services/api";
import AppRouter from "./routers";
import { ErrorBoundary } from "react-error-boundary";
import ErrorFallBack from "./componentes/errorBoundry";

function App(): JSX.Element {
  //const prefersDarkMode = useMediaQuery("(prefers-color-scheme: dark)");
  const [colorMode, setColorMode] = useState<boolean>(true);
  const { setPages, checkLogin, setCheckLogin, setLoadingPages } = usePages();
  const [isConnected, setIsConnected] = useState(socket.connected);

  const theme = useMemo(() => myTheme(colorMode), [colorMode]);

  /*   useEffect(() => {
    setColorMode(prefersDarkMode);
  }, [prefersDarkMode]);
  //
 */
  useEffect(() => {
    const colorModeStorage = JSON.parse(
      localStorage.getItem("theme") || "null"
    );
    if (colorModeStorage) {
      setColorMode(colorModeStorage.colorMode);
    }
  }, []);

  useEffect(() => {
    // Define o estilo a ser aplicado com base no modo de cor
    //outra opcap de cor para o background 29323B
    const style = `
      ::-webkit-scrollbar {
        width: 9px;
        height: 9px;        
      }
 
      ::-webkit-scrollbar-track {
        background: ${colorMode ? "#1D242C" : "#e2e2e2"};
      }
      ::-webkit-scrollbar-thumb {
        border-radius: 8px; 
        background: ${colorMode ? "#637381" : "#b3b3b3"};
      }
      ::-webkit-scrollbar-thumb:hover {
        background: ${colorMode ? "#8196A8" : "#8f8e8e"};
      }
    `;

    // Cria o elemento <style> e adiciona o CSS
    const styleElement = document.createElement("style");
    styleElement.type = "text/css";

    // Verifica compatibilidade para inserir o CSS
    styleElement.textContent = style;
    // Adiciona o elemento <style> ao <head> do documento
    document.head.appendChild(styleElement);
    // Remove o estilo ao desmontar o componente
    return () => {
      document.head.removeChild(styleElement);
    };
  }, [colorMode]);

  useEffect(() => {
    if (!checkLogin) return;
    getPageFormate();
  }, [checkLogin]);
  useEffect(() => {
    function onConnect() {
      setIsConnected(true);
      socket.emit(
        "first_connection",
        `Frontend cliente estabeleceu conexão, id conection: ${socket.id}`
      );
    }
    function onDisconnect() {
      setIsConnected(false);
    }
    function connectErrorEvent(error: Error): void {
      console.log("Socket error - erro de conexão:", error);
    }
    function reconnectAttemptEvent(attempt: number): void {
      console.log(
        `Socket warn - o servido esta tentando ser reconectar. N de tentativas: ${attempt}`
      );
    }
    function reconnectErrorEvent(error: Error): void {
      console.log("Socket error - erro de reeconexão:", error);
    }
    function reconnectEvent(): void {
      console.log("Socket success: servidor reeconectado com sucesso");
    }
    if (!checkLogin) {
      if (isConnected) socket.disconnect();
    }

    if (checkLogin) {
      //atualiza query socket para enviar id do usuarioCliente
      socket.io.opts.query = {
        usuarioClienteId: JSON.parse(String(localStorage.getItem("1")))
          ?.usuarioCliente?.id,
        logsLoginClienteId: JSON.parse(localStorage.getItem("logs") || "{}")
          ?.id,
      };
      socket.connect();

      socket.on("connect", onConnect);
      socket.on("disconnect", onDisconnect);
      socket.on("connect_error", connectErrorEvent);
      socket.io.on("reconnect_attempt", reconnectAttemptEvent);
      socket.io.on("reconnect_error", reconnectErrorEvent);
      socket.io.on("reconnect", reconnectEvent);

      return () => {
        socket.off("connect", onConnect);
        socket.off("disconnect", onDisconnect);
        socket.off("connect_error", connectErrorEvent);
        socket.io.off("reconnect_attempt", reconnectAttemptEvent);
        socket.io.off("reconnect_error", reconnectErrorEvent);
        socket.io.off("reconnect", reconnectEvent);
      };
    }
  }, [checkLogin]);
  // useEffect(() => {
  //   function onConnect() {
  //     setIsConnected(true);
  //     socket.emit(
  //       "first_connection",
  //       `Frontend cliente estabeleceu conexão, id conection: ${socket.id}`
  //     );
  //   }
  //   function onDisconnect() {
  //     setIsConnected(false);
  //   }
  //   function connectErrorEvent(error: Error): void {
  //     console.log("Socket error - erro de conexão:", error);
  //   }
  //   function reconnectAttemptEvent(attempt: number): void {
  //     console.log(
  //       `Socket warn - o servido esta tentando ser reconectar. N de tentativas: ${attempt}`
  //     );
  //   }
  //   function reconnectErrorEvent(error: Error): void {
  //     console.log("Socket error - erro de reeconexão:", error);
  //   }
  //   function reconnectEvent(): void {
  //     console.log("Socket success: servidor reeconectado com sucesso");
  //   }
  //   if (!checkLogin) {
  //     if (isConnected) socketCliente.disconnect();
  //   }

  //   if (checkLogin) {
  //     //atualiza query socketCliente para enviar id do usuarioCliente
  //     socket.io.opts.query = {
  //       usuarioClienteId: JSON.parse(String(localStorage.getItem("1")))
  //         ?.usuarioCliente?.id,
  //     };
  //     socketCliente.connect();

  //     socketCliente.on("connect", onConnect);
  //     socketCliente.on("disconnect", onDisconnect);
  //     socketCliente.on("connect_error", connectErrorEvent);
  //     socketCliente.io.on("reconnect_attempt", reconnectAttemptEvent);
  //     socketCliente.io.on("reconnect_error", reconnectErrorEvent);
  //     socketCliente.io.on("reconnect", reconnectEvent);

  //     return () => {
  //       socketCliente.off("connect", onConnect);
  //       socketCliente.off("disconnect", onDisconnect);
  //       socketCliente.off("connect_error", connectErrorEvent);
  //       socketCliente.io.off("reconnect_attempt", reconnectAttemptEvent);
  //       socketCliente.io.off("reconnect_error", reconnectErrorEvent);
  //       socketCliente.io.off("reconnect", reconnectEvent);
  //     };
  //   }
  // }, [checkLogin]);

  async function getPageFormate() {
    try {
      setLoadingPages(true);
      const response = await api.get("/pages/findMany");
      if (response.data.status === "Error") {
        throw new Error();
      }
      //const pageFormat = response.data as DashWithCardsGraphics[];
      const url = new URL(window.location.href);
      if (!Array.isArray(response.data)) {
        window.location.href = url.origin + "/login";
        localStorage.clear();
        return;
      } else {
        setPages(response.data);
      }
    } catch (e) {
      throw e;
    } finally {
      setLoadingPages(false);
    }
  }

  return (
    <ThemeProvider theme={theme}>
      <NotificationProvider>
        <CssBaseline />
        <div className="App">
          <ErrorBoundary FallbackComponent={ErrorFallBack}>
            <AppRouter
              socket={socket}
              setCheckLogin={setCheckLogin}
              checkLogin={checkLogin}
              setColorMode={setColorMode}
              colorMode={colorMode}
            />
          </ErrorBoundary>
        </div>
      </NotificationProvider>
    </ThemeProvider>
  );
}

export default App;
